// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21.9995 2H1.99951V22H21.9995V2ZM12.9995 18H10.9995V7H12.9995V18ZM7.99951 18H5.99951V11H7.99951V18ZM15.9995 18V13H17.9995V18H15.9995Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chart-filled')
export default class ChartFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-filled',
    }
  }
}
